export function leftOrMiddleClickDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: leftOrMiddleClickDirectiveCtrl,
	};
}

export class leftOrMiddleClickDirectiveCtrl {
	constructor($element, $attrs, $scope) {
		'ngInject';
		$element.on('auxclick click', $event => {
			if ($event.button === 2) {
				// ignore right clicks
				return;
			}
			$scope.$eval($attrs.shLeftOrMiddleClick, { $event });
		});
	}
}
